import axios from 'axios';
import { API_URL, ENDPOINTS } from './api';
import { getToken } from '../utils/TokenUtils';
import { notification } from 'antd';

export const updateColumn = async (e, href) => {
  const token = getToken();
  e.preventDefault();
  const description = prompt('Please enter a description for updating:');

  // If user cancels or enters nothing, stop the submission
  if (!description) {
    alert('Update canceled. Description is required.');
    return;
  }
  // Encode the description for URL
  const encodedDescription = encodeURIComponent(description);

  const updateUrl = `${API_URL}/${ENDPOINTS.SYS}/${href}/${encodedDescription}`;
  console.log('updateUrl:', updateUrl);
  try {
    const response = await axios.put(
      updateUrl,
      {},
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );

    //console.log(`response: `,response.data)
    notification.success({ message: response.data.message });
  } catch (error) {
    //console.log(`url: ${updateUrl}, error ${error.message}`)
    notification.error({ message: error.message });
  }
};
